import { Link } from "@tanstack/react-router"
import { ThemeSwitch } from "../ThemeSwitch"
import LogoIcon from "../icons/LogoIcon"

const CustomAppBar = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 w-full items-center justify-between px-4 md:px-8">
        <Link
          to="/"
          className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
        >
          <LogoIcon variant="horizontal" className="w-72" />
        </Link>
        <nav className="flex items-center space-x-2">
          <ThemeSwitch />
        </nav>
      </div>
    </header>
  )
}

export default CustomAppBar
